module.exports = __webpack_public_path__ + "img/amaury_crescendo.8ea413fc.jpg";